import request from '@/utils/request';
export const defaultMoqData = {
  id: 0,
  enabled: true,
  name: '',
  startDate: '',
  endDate: '',
  image: null
};
export const getMoqs = params => request({
  url: '/moqs',
  method: 'get',
  params
});
export const getMoqById = id => request({
  url: `/moqs/${id}`,
  method: 'get'
});
export const updateMoq = (id, data) => request({
  url: `/moqs/${id}`,
  method: 'patch',
  data
});
export const deleteMoq = id => request({
  url: `/moqs/${id}`,
  method: 'delete'
});
export const createMoq = data => request({
  url: '/moqs',
  method: 'post',
  data
});
export const importMoqsDiscount = data => request({
  url: '/moqs-discounts/import',
  method: 'post',
  data
});